import { colorCSS } from "../../styles";

export const ChevronRight = ({ color }: { color?: string }) => {
    return (
        <svg
            fill={color ? colorCSS(color) : "currentColor"}
            height="13"
            viewBox="0 0 8 13"
            width="8"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="m6.73053 5.59279c.36263.36263.38855.93447.07773 1.32699l-.07773.08722-4.99999 5c-.39052.3905-1.023684.3905-1.414209 0-.3626298-.3626-.3885324-.9345-.077707-1.327l.077707-.0872 4.292859-4.29362-4.292859-4.29216c-.3626291-.36263-.3885324-.9345-.077707-1.327017l.077707-.087201c.36263-.36263.934469-.388554 1.326989-.077729l.08722.077729z" />
        </svg>
    );
};
